import { render, staticRenderFns } from "./EditWorkflow.vue?vue&type=template&id=f6f9e8d6&scoped=true&"
import script from "./EditWorkflow.vue?vue&type=script&lang=js&"
export * from "./EditWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./EditWorkflow.vue?vue&type=style&index=0&id=f6f9e8d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f9e8d6",
  null
  
)

export default component.exports